// extracted by mini-css-extract-plugin
export default {"container":"HomePage_container_K_93b","spinAround":"HomePage_spinAround_63bUw"};